/**
 * Founder identity — FILL THIS IN.
 *
 * The site audit scored founder-led trust 1/4 (Fail): no named founder, no
 * photo, no LinkedIn anywhere on the site, while the category leader
 * (Sudowrite) names Amit Gupta and James Yu with investor backing. In a
 * creative-writing product, a faceless brand loses to a visible person.
 *
 * Everything that renders a founder — the /about page and the footer block —
 * reads from here and renders NOTHING until `name` is non-empty. That is
 * deliberate: a placeholder name or a stock photo would be worse than the gap
 * it fills, because it is a fabricated identity on a trust surface.
 *
 * To turn it on, fill in `name`, drop a real photo at the path below, and add
 * the LinkedIn URL. Everything else is already written.
 */
export interface Founder {
  /** Real full name. Leave empty and the founder blocks stay hidden. */
  name: string;
  /** e.g. "Founder" or "Founder & Engineer". */
  role: string;
  /** Put the file in client/public/ and reference it as "/founder.jpg". */
  photo: string;
  /** Full https:// URL. Optional — the link is skipped if empty. */
  linkedin: string;
  /** Optional. Full https:// URL. */
  twitter: string;
  /**
   * One line, first person, plain. The audit's own suggestion, which is in the
   * audience's vocabulary and names the pain the product exists for.
   */
  bio: string;
}

export const FOUNDER: Founder = {
  name: '',
  role: 'Founder',
  photo: '',
  linkedin: '',
  twitter: '',
  bio: 'I built ShakespeareAI because ChatGPT forgot my characters by chapter 5.',
};

/** True once there is a real person to show. */
export const hasFounder = (): boolean => FOUNDER.name.trim().length > 0;
